import { Component } from '@angular/core';

/**
 * Demonstrate the usage of {@link GridComponent}
 */
@Component({
  templateUrl: './grid-demo.component.html',
  styleUrls: ['./grid-demo.component.scss'],
})
export class GridDemoComponent {
}



// WEBPACK FOOTER //
// ./src/app/grid/grid-demo.component.ts